import { useQuery } from '@tanstack/react-query';
import { timesheetService } from '@/services/timesheets/timesheetService';
import { timesheetQueryKeys } from './queryKeys';
import type { TimesheetFilters, PaginatedTimeEntries } from '@/services/timesheets/types';

export const useCompanyTimeEntries = (filters: TimesheetFilters) => {
  return useQuery<PaginatedTimeEntries>({
    queryKey: timesheetQueryKeys.companyTimeEntriesWithComments(filters),
    queryFn: () => timesheetService.getCompanyTimeEntriesWithComments(filters),
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });
};
